module.exports = __webpack_public_path__ + "img/down-success.82dd0caa.png";